/* ============================================================
   Dr Forest — search synonyms and routing (df-search-synonyms.js)

   PLAIN-ENGLISH FILE. Edit this, not the search engine.

   Each group says: "when someone searches any of these words,
   also show them what a search for TO would return".
   Nothing in here is ever displayed on the site — these words
   route a search, they do not appear as text anywhere.

   Direct matches always rank first. These only fill in behind
   them, or carry the whole result when there is no direct match.

   Deliberately NOT in this file: anything pest related (aphids,
   blackfly, slugs, red spider mite, moss). Routing those queries
   to the plant soaps would associate the products with pest
   control and risks Plant Protection Product classification.
   Leave it that way.
   ============================================================ */
(function () {
  'use strict';

  var GROUPS = [

    /* ---- Other brands gardeners are switching from ----------
       Trade marks of other companies, used only to route a
       search. Delete this whole block if you would rather not
       hold them. ------------------------------------------- */
    { to: 'all purpose fertiliser', from: ['growmore', 'grow more', 'miracle gro', 'miraclegro', 'miracle grow', 'phostrogen', '6x', 'vitax', 'westland', 'doff', 'gro sure'] },
    { to: 'tomato fertiliser', from: ['tomorite', 'tomato feed brand'] },
    { to: 'liquid fertiliser', from: ['baby bio', 'chempak'] },
    { to: 'slow release fertiliser', from: ['osmocote'] },
    { to: 'seaweed', from: ['seasol', 'maxicrop'] },

    /* ---- Animal inputs -> our plant-based equivalents --------
       Someone searching these is looking for a product we do
       not make. Route them to what we do make instead. ------ */
    { to: 'all purpose fertiliser', from: ['blood fish and bone', 'blood fish bone', 'fish blood and bone', 'bfb'] },
    { to: 'rock phosphate phosphorus', from: ['bone meal', 'bonemeal', 'bone meal fertiliser'] },
    { to: 'nitrogen fertiliser', from: ['chicken manure', 'chicken pellets', 'poultry manure', 'pelleted chicken', 'fish emulsion', 'fish fertiliser', 'hoof and horn', 'dried blood'] },
    { to: 'soil conditioner bokashi', from: ['horse manure', 'farmyard manure', 'well rotted manure', 'worm cast', 'wormcast', 'worm castings', 'vermicompost'] },

    /* ---- Category and generic wording ---------------------- */
    { to: 'fertiliser', from: ['plant food', 'plant feed', 'feed', 'npk', 'granular feed'] },
    { to: 'soil conditioner', from: ['compost', 'soil improver', 'top dressing', 'topdressing', 'mulch', 'soil amendment'] },
    { to: 'liquid fertiliser', from: ['liquid feed', 'foliar feed', 'foliar spray', 'watering can feed'] },

    /* ---- Vegetables ---------------------------------------- */
    { to: 'fruit vegetable fertiliser', from: ['courgette', 'courgettes', 'marrow', 'squash', 'pumpkin', 'pumpkins', 'cucumber', 'cucumbers', 'pepper', 'peppers', 'chilli', 'chillies', 'aubergine', 'aubergines', 'sweetcorn'] },
    { to: 'fruit vegetable fertiliser', from: ['onion', 'onions', 'garlic', 'leek', 'leeks', 'shallots', 'carrot', 'carrots', 'parsnip', 'parsnips', 'beetroot', 'swede', 'turnip'] },
    { to: 'fruit vegetable fertiliser', from: ['cabbage', 'brassicas', 'sprouts', 'brussels sprouts', 'kale', 'broccoli', 'cauliflower', 'lettuce', 'salad', 'spinach', 'chard'] },
    { to: 'fruit vegetable fertiliser', from: ['peas', 'beans', 'runner beans', 'broad beans', 'french beans', 'rhubarb', 'asparagus', 'celery'] },
    { to: 'all purpose fertiliser', from: ['allotment', 'veg patch', 'vegetable patch', 'raised bed', 'raised beds', 'no dig', 'kitchen garden', 'herbs', 'basil', 'mint', 'parsley'] },

    /* ---- Fruit --------------------------------------------- */
    { to: 'fruit vegetable fertiliser', from: ['apple', 'apples', 'pear', 'pears', 'plum', 'plums', 'cherry', 'cherries', 'fruit tree', 'fruit trees', 'orchard', 'raspberry', 'raspberries', 'blackberry', 'gooseberry', 'currants', 'blackcurrant', 'redcurrant', 'grape', 'grapes', 'vine', 'figs'] },

    /* ---- Acid-loving plants -------------------------------- */
    { to: 'sulphur soil acidifier', from: ['blueberry', 'blueberries', 'cranberry', 'azalea', 'azaleas', 'rhododendron', 'rhododendrons', 'camellia', 'camellias', 'heather', 'pieris', 'ericaceous', 'acid loving', 'acid loving plants', 'lime hating', 'hydrangea', 'hydrangeas', 'blue hydrangea', 'acer', 'acers', 'japanese maple'] },

    /* ---- Flowers ------------------------------------------- */
    { to: 'bloom fertiliser', from: ['dahlia', 'dahlias', 'begonia', 'begonias', 'fuchsia', 'fuchsias', 'geranium', 'geraniums', 'petunia', 'petunias', 'bedding plants', 'hanging basket', 'hanging baskets', 'patio pots', 'containers', 'sweet pea', 'sweet peas', 'bulbs', 'daffodils', 'tulips', 'lilies', 'peony', 'peonies'] },
    { to: 'bloom fertiliser', from: ['no flowers', 'not flowering', 'wont flower', 'few flowers', 'more flowers', 'no fruit', 'poor fruit set', 'fruit set', 'flower boost'] },
    { to: 'rose fertiliser', from: ['clematis', 'wisteria', 'climber', 'climbers', 'david austin', 'shrub rose', 'climbing rose'] },

    /* ---- Trees, hedges, lawns ------------------------------
       Conifers added 21 Aug 2026 after "scots pine" turned up
       in the no-results report. ---------------------------- */
    { to: 'all purpose fertiliser', from: ['hedge', 'hedges', 'hedging', 'conifer', 'conifers', 'leylandii', 'box', 'topiary', 'shrub', 'shrubs', 'tree', 'trees', 'evergreen', 'evergreens', 'wildflower', 'meadow'] },
    { to: 'all purpose fertiliser', from: ['pine', 'pines', 'scots pine', 'scots pines', 'scotch pine', 'spruce', 'fir', 'douglas fir', 'christmas tree', 'christmas trees', 'yew', 'juniper', 'thuja', 'cedar', 'larch', 'cypress'] },
    { to: 'lawn fertiliser', from: ['grass', 'turf', 'lawn feed', 'lawn food', 'lawns', 'new lawn', 'grass seed feed', 'scarifying', 'after scarifying'] },

    /* ---- Problems and symptoms ----------------------------- */
    { to: 'nitrogen magnesium', from: ['yellow leaves', 'yellowing leaves', 'yellowing', 'chlorosis', 'pale leaves', 'pale growth'] },
    { to: 'cal mag calcium', from: ['blossom end rot', 'ber', 'bitter pit', 'calcium deficiency', 'tip burn'] },
    { to: 'gypsum clay breaker', from: ['clay soil', 'heavy soil', 'compacted soil', 'waterlogged', 'clay breaker', 'break up clay'] },
    { to: 'montmorillonite clay', from: ['sandy soil', 'free draining soil', 'dries out', 'water retention'] },
    { to: 'wetting agent', from: ['dry patch', 'dry patches', 'hydrophobic', 'water repellent', 'water runs off', 'wont absorb water'] },
    { to: 'sulphur soil acidifier', from: ['lower ph', 'reduce ph', 'acidify', 'acidify soil', 'soil too alkaline', 'chalky soil'] },
    { to: 'calcium carbonate shell meal', from: ['lime', 'liming', 'garden lime', 'raise ph', 'increase ph', 'soil too acidic', 'sour soil'] },
    { to: 'mycorrhizal fungi', from: ['transplant shock', 'root growth', 'rooting', 'planting out', 'new planting', 'replant disorder', 'root booster'] },
    { to: 'seedling fertiliser', from: ['seedlings', 'seedling', 'seed sowing', 'propagation', 'plugs', 'young plants', 'starter feed'] },

    /* ---- Nutrients and inputs ------------------------------ */
    { to: 'kieserite magnesium', from: ['magnesium', 'epsom', 'epsom salt', 'epsom salts', 'mgso4'] },
    { to: 'cal mag calcium', from: ['calcium', 'calmag'] },
    { to: 'sulphate of potash', from: ['potassium', 'potash', 'sop', 'k2so4', 'high potash'] },
    { to: 'rock phosphate phosphorus', from: ['phosphorus', 'phosphate', 'phosphorous'] },
    { to: 'nitrogen fertiliser', from: ['nitrogen', 'high nitrogen', 'protein feed'] },
    { to: 'sulphur', from: ['sulfur', 'sulphate', 'elemental sulphur'] },
    { to: 'mineral mix micronutrients', from: ['trace elements', 'trace minerals', 'micronutrients', 'micro nutrients', 'boron', 'zinc', 'iron', 'manganese', 'molybdenum', 'copper', 'deficiency'] },
    { to: 'volcanic rock dust', from: ['silica', 'silicon', 'basalt', 'rock dust', 'remineralise'] },
    { to: 'humic fulvic acid', from: ['humic', 'fulvic', 'humate', 'carbon feed'] },
    { to: 'amino acid fertiliser', from: ['amino', 'amino acids', 'protein hydrolysate'] },
    { to: 'seaweed biostimulant', from: ['kelp', 'biostimulant', 'growth promoter', 'triacontanol'] },
    { to: 'mycorrhizal em1 bokashi', from: ['microbes', 'bacteria', 'probiotic', 'soil biology', 'living soil', 'mycorrhizae', 'myco', 'inoculant', 'compost tea'] },
    { to: 'molasses', from: ['sugar', 'blackstrap', 'microbe food', 'carbohydrate feed'] },

    /* ---- Sizes and quantity -------------------------------- */
    { to: '18kg 30kg', from: ['bulk', 'bulk bag', 'big bag', 'large bag', 'trade', 'wholesale', 'commercial'] },
    { to: '500g 750g', from: ['small bag', 'trial size', 'try before'] }
  ];

  /* Shown in the dropdown before anyone types, and when a search
     comes back empty. Keep it to six or so. */
  window.DF_SEARCH_POPULAR = [
    { label: 'Tomato feed', url: '/products/organic-tomato-fertiliser' },
    { label: 'Rose fertiliser', url: '/products/organic-rose-fertiliser' },
    { label: 'All purpose 4-4-4', url: '/products/organic-all-purpose-fertiliser-4-4-4' },
    { label: 'Bloom 2-8-4', url: '/products/organic-bloom-fertiliser-2-8-4' },
    { label: 'Lawn care', url: '/collections/lawn-care' },
    { label: 'All fertilisers', url: '/collections/premium-organic-fertilisers' }
  ];

  /* Flatten into { phrase: 'target query' } for the search engine. */
  var map = {};
  GROUPS.forEach(function (g) {
    g.from.forEach(function (phrase) {
      var key = String(phrase).toLowerCase().replace(/[^a-z0-9\s]+/g, ' ').replace(/\s+/g, ' ').trim();
      if (key) map[key] = g.to;
    });
  });
  window.DF_SEARCH_SYNONYMS = map;
})();
